export const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
    let dotNodes = []
  
    const addDotBtnsWithClickHandlers = () => {
      dotsNode.innerHTML = emblaApi
        .scrollSnapList()
        .map(() => '<button class="embla__dot" aria-label="Navigation dans les slides" aria-selected="false" role="tab" type="button"></button>')
        .join('')
  
      dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false)
      })
    }
  
    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap()
      const selected = emblaApi.selectedScrollSnap()

      if (dotNodes[previous]) {
        dotNodes[previous].classList.remove('embla__dot--selected')
        dotNodes[previous].setAttribute('aria-selected', 'false')
      }

      if (dotNodes[selected]) {
        dotNodes[selected].classList.add('embla__dot--selected')
        dotNodes[selected].setAttribute('aria-selected', 'true')
      }
    }
  
    emblaApi
      .on('init', addDotBtnsWithClickHandlers)
      .on('reInit', addDotBtnsWithClickHandlers)
      .on('init', toggleDotBtnsActive)
      .on('reInit', toggleDotBtnsActive)
      .on('select', toggleDotBtnsActive)
  
    return () => {
      dotsNode.innerHTML = ''
    }
}
  